import type { Permissions } from '@wix/wix-data-schema-types'
import { PermissionRole } from '@wix/wix-data-schema-types'
import { isEqual } from 'lodash'

export enum Preset {
  CONTENT_FOR_YOUR_SITE = 'CONTENT_FOR_YOUR_SITE',
  FORM_INPUTS = 'FORM_INPUTS',
  USER_GENERATED_CONTENT = 'USER_GENERATED_CONTENT',
  CONTENT_FOR_SITE_MEMBERS = 'CONTENT_FOR_SITE_MEMBERS',
  FORM_INPUTS_FOR_SITE_MEMBERS = 'FORM_INPUTS_FOR_SITE_MEMBERS',
  PRIVATE_DATA = 'PRIVATE_DATA',
  CUSTOM = 'CUSTOM',
}

type PermissionsByPreset = {
  [K in Preset]: Permissions
}

export const PermissionsByPreset: PermissionsByPreset = {
  CONTENT_FOR_YOUR_SITE: {
    insert: PermissionRole.admin,
    read: PermissionRole.anyone,
    update: PermissionRole.admin,
    remove: PermissionRole.admin,
  },

  FORM_INPUTS: {
    insert: PermissionRole.anyone,
    read: PermissionRole.admin,
    update: PermissionRole.admin,
    remove: PermissionRole.admin,
  },

  USER_GENERATED_CONTENT: {
    insert: PermissionRole.siteMember,
    read: PermissionRole.anyone,
    update: PermissionRole.siteMemberAuthor,
    remove: PermissionRole.siteMemberAuthor,
  },

  CONTENT_FOR_SITE_MEMBERS: {
    insert: PermissionRole.admin,
    read: PermissionRole.siteMember,
    update: PermissionRole.admin,
    remove: PermissionRole.admin,
  },

  FORM_INPUTS_FOR_SITE_MEMBERS: {
    insert: PermissionRole.siteMember,
    read: PermissionRole.admin,
    update: PermissionRole.admin,
    remove: PermissionRole.admin,
  },

  PRIVATE_DATA: {
    insert: PermissionRole.admin,
    read: PermissionRole.admin,
    update: PermissionRole.admin,
    remove: PermissionRole.admin,
  },

  CUSTOM: {},
}

export const getPermissionsByPreset = (preset: Preset): Permissions => {
  if (!PermissionsByPreset[preset]) {
    throw new Error(`Unkown preset preset ${preset}`)
  }
  return PermissionsByPreset[preset]
}

export const findPresetByPermissions = (permissions: Permissions): Preset => {
  const preset: Preset = Object.keys(PermissionsByPreset).find(preset =>
    isEqual(PermissionsByPreset[preset as Preset], permissions),
  ) as Preset
  return preset || Preset.CUSTOM
}
